var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4752 4.074C16.8484 4.07092 16.1828 4.07092 15.4752 4.07092C9.50412 4.07092 6.51856 4.07092 4.66356 5.92591C2.80858 7.78091 2.80858 10.7665 2.80858 16.7376C2.80858 22.7087 2.80858 25.6943 4.66356 27.5493C6.51856 29.4043 9.50412 29.4043 15.4752 29.4043C21.4463 29.4043 24.4319 29.4043 26.287 27.5493C28.0715 25.7647 28.1392 22.9336 28.1418 17.4043",
    stroke: "#218F54",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80858 18.9181C3.63394 18.7982 4.46837 18.739 5.30419 18.7412C8.84011 18.6664 12.2894 19.7681 15.0367 21.8498C17.5846 23.7804 19.3748 26.4375 20.1419 29.4043",
    stroke: "#218F54",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1419 22.5992C26.5747 21.8054 24.9536 21.4026 23.3235 21.4044C20.8546 21.3946 18.4106 22.302 16.1419 24.0709",
    stroke: "#218F54",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8086 6.07094C23.4639 5.39668 25.2083 2.73761 26.1419 2.73761M26.1419 2.73761C27.0755 2.73761 28.8199 5.39668 29.4752 6.07094M26.1419 2.73761V13.4043",
    stroke: "#218F54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/Image-Upload.5b3bc3bacdb52c5f8873204b6c2ec882.svg";
export { ForwardRef as ReactComponent };